import { api } from '@/api/client'

const resolveApiOrigin = (apiUrl?: string) => {
  if (!apiUrl || apiUrl.startsWith('/')) return ''

  try {
    return new URL(apiUrl).origin
  } catch {
    return ''
  }
}

const API_ORIGIN = resolveApiOrigin(api.defaults.baseURL)

export const resolveAttachmentUrl = (url: string) => {
  if (!url) return url

  if (/^https?:\/\//i.test(url)) return url

  if (!API_ORIGIN) return url

  const normalizedUrl = url.startsWith('/avatars/') ? `/api${url}` : (url.startsWith('/') ? url : `/${url}`)
  return `${API_ORIGIN}${normalizedUrl}`
}
